import request from '@/utils/request'

const api = {
  Query(data) {
    return request({
      url: 'admin/account/query',
      method: 'post',
      data
    })
  },
  Delete(data) {
    return request({
      url: 'admin/account/delete',
      method: 'post',
      data
    })
  },
  Update(data) {
    return request({
      url: 'admin/account/createOrUpdate',
      method: 'post',
      data
    })
  },
  Create(data) {
    return request({
      url: 'admin/account/createOrUpdate',
      method: 'post',
      data
    })
  },
  Detail(id) {
    return request({
      url: 'admin/account/detail',
      method: 'post',
      params: { id }
    })
  },
  ResetPwd(data) {
    return request({
      url: 'admin/account/resetPwd',
      method: 'post',
      data
    })
  },
  SetNums(data) {
    return request({
      url: 'admin/account/setNums',
      method: 'post',
      data
    })
  },
  SetAlNums(data) {
    return request({
      url: 'admin/account/setAlNums',
      method: 'post',
      data
    })
  },
  ChangePassword(data) {
    return request({
      url: 'admin/account/changePassword',
      method: 'post',
      data
    })
  },
  SaveSimple(data) {
    return request({
      url: 'admin/account/save_simple',
      method: 'post',
      data
    })
  },
  Login(data) {
    return request({
      url: '/admin/account/login',
      method: 'post',
      data
    })
  },
  GetInfo(data) {
    return request({
      url: '/admin/account/info',
      method: 'post',
      data
    })
  },
  Logout() {
    return request({
      url: 'admin/account/logout',
      method: 'post'
    })
  },
  UpdateInfo(data) {
    return request({
      url: 'admin/account/updateInfo',
      method: 'post',
      data
    })
  },
  GetAuthList() {
    return request({
      url: 'admin/account/getAuthList',
      method: 'post'
    })
  }
}

export default api
